module.exports = __webpack_public_path__ + "img/De-studio.0fa49a3c.gif";